import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { LeafAngularWrapper } from '../leaf-angular-wrapper';

import '@cigna/leaf-web/lib/wc/components/tab-panel/tab-panel';

@Component({
  selector: 'cigna-leaf-tab-panel',
  template: `
    <leaf-tab-panel slot="panel">
      <ng-content></ng-content>
    </leaf-tab-panel>
  `,
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CignaLeafTabPanelComponent extends LeafAngularWrapper {}
